import { ListFieldsKeys, ListFieldsType, listFields } from "src/api/config";
import moment from "moment";
import { FIELDS_TYPES } from "src/api/config/type.config";
import { strapiUrl } from "src/modules/users/constants";
import axios from "axios";
import _ from "lodash";
import { listMap } from "src/api/config/systemSwitch";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";
import {
  prepareWorkstationNewUsersContext,
  syncWorkstationNewUsersFamiliarization,
} from "./syncWorkstationNewUsersFamiliarization";

export type UpdateItemRequestProps<L extends ListFieldsKeys> = {
  listName: L;
  body: Partial<Record<keyof ListFieldsType[L], any>>;
  bodyArr?: Partial<Record<keyof ListFieldsType[L], any>>[];
  update?: boolean;
  updateStatus?: boolean;
  anySite?: string;
};
// указал динамический тип названия списка
export const updateItemRequest = <L extends ListFieldsKeys>({
  listName,
  body,
  bodyArr,
  anySite,
}: UpdateItemRequestProps<L>) => {
  const fields = listFields[listName];
  const listStrapiApi = listMap[listName].replace(":folder", "");
  let addObj: Record<string, any> = {};
  let addArr: any = [];
  let emails: string[] = [];
  const workstationNewUsersContextPromise = prepareWorkstationNewUsersContext({
    listName,
    body,
    bodyArr,
  });
  if (bodyArr && bodyArr.length > 0) {
    bodyArr.forEach((item: any) => {
      let strapiObjData: any = {};
      Object.keys(item).forEach((key) => {
        switch (key) {
          case "Type5Way":
            strapiObjData["Type5Why"] = item[key];
            break;
          case "Date5Way":
            strapiObjData["Date5Why"] = item[key];
            break;
          case "Region":
            strapiObjData["Area"] = item[key];
            break;
          case "_x0035_Way":
            strapiObjData["FiveWhy"] = item[key];
            break;
          case "KPI":
            strapiObjData["Kpi"] = item[key];
            break;
          case "Status":
            if (listStrapiApi === "mt-meetings") {
              strapiObjData["Statuses"] = item[key];
            } else {
              strapiObjData["CardStatus"] = item[key];
            }
            break;
          case "Sector":
            strapiObjData["Column"] = item[key];
            break;
          case "Process":
            strapiObjData["ColumnBlockArea"] = item[key];
            break;
          case "DocumentID":
            strapiObjData["IDDocument"] = item[key];
            break;
          case "ID":
            strapiObjData["id"] = item[key];
            break;
          default:
            strapiObjData[key] = item[key];
            break;
        }
      });
      let addObjinArr: Record<string, any> = {};
      Object.keys(strapiObjData).forEach((fieldKey) => {
        const key = fieldKey as keyof typeof strapiObjData;
        const value = strapiObjData[key];
        const fieldType = fields[key as keyof typeof fields];

        switch (fieldType) {
          case FIELDS_TYPES.DATE:
            if (_.isDate(value)) {
              let dateField = moment(value).toISOString();
              addObjinArr = { ...addObjinArr, [key]: dateField };
            }
            break;
          case FIELDS_TYPES.ID:
            break;
          case FIELDS_TYPES.BOOLEAN:
            addObjinArr = { ...addObjinArr, [key]: value ? true : false };
            break;
          case FIELDS_TYPES.USER:
            emails = [...emails, value];
            addObjinArr = { ...addObjinArr, [key]: value };
            break;
          case FIELDS_TYPES.MULTI_USER:
            emails = [...emails, ...value];
            addObjinArr = { ...addObjinArr, [key]: value };
            break;
          default:
            addObjinArr = { ...addObjinArr, [key]: value };
            break;
        }
      });
      addArr = [...addArr, addObjinArr];
    });
  } else if (body) {
    let strapiObjData: any = {};
    Object.keys(body).forEach((key) => {
      switch (key) {
        case "Type5Way":
          strapiObjData["Type5Why"] = body[key];
          break;
        case "Date5Way":
          strapiObjData["Date5Why"] = body[key];
          break;
        case "Region":
          strapiObjData["Area"] = body[key];
          break;
        case "_x0035_Way":
          strapiObjData["FiveWhy"] = body[key];
          break;
        case "KPI":
          strapiObjData["Kpi"] = body[key];
          break;
        case "Status":
          if (listStrapiApi === "mt-meetings") {
            strapiObjData["Statuses"] = body[key];
          } else {
            strapiObjData["CardStatus"] = body[key];
          }
          break;
        case "Sector":
          strapiObjData["Column"] = body[key];
          break;
        case "Process":
          strapiObjData["ColumnBlockArea"] = body[key];
          break;
        case "DocumentID":
          strapiObjData["IDDocument"] = body[key];
          break;
        case "ID":
          strapiObjData["id"] = body[key];
          break;
        default:
          strapiObjData[key] = body[key];
          break;
      }
    });
    Object.keys(strapiObjData).forEach((fieldKey) => {
      const key = fieldKey as keyof typeof strapiObjData;
      const value = strapiObjData[key];
      const fieldType = fields[key as keyof typeof fields];
      switch (fieldType) {
        case FIELDS_TYPES.DATE:
          if (_.isDate(value)) {
            let dateField = moment(value).toISOString();
            addObj = { ...addObj, [key]: dateField };
          }
          break;
        case FIELDS_TYPES.ID:
          break;
        case FIELDS_TYPES.BOOLEAN:
          addObj = { ...addObj, [key]: value ? true : false };
          break;
        case FIELDS_TYPES.USER:
          addObj = { ...addObj, [key]: value };
          emails = [...emails, value];
          break;
        case FIELDS_TYPES.MULTI_USER:
          addObj = { ...addObj, [key]: value };
          emails = [...emails, ...value];
          break;
        default:
          addObj = { ...addObj, [key]: value };
          break;
      }
    });
  }
  return new Promise(async (resolve, reject) => {
    let token: string | null = null;

    if (!isPWA()) {
      const result = await SecureStoragePlugin.get({ key: 'accessToken' });
      token = result.value;
    }

    const headers = {
      Accept: "application/json;odata=nometadata",
      "Content-Type": "application/json;odata=nometadata",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    if (addArr.length > 0) {
      if (emails.length > 0) {
        let sendAddArr: Record<string, any>[] = [];
        const query = [..._.uniqWith(emails, _.isEqual)]
          .filter((e) => e && e !== "undefined" && e !== "null")
          .map((e) => `filters[email][$in]=${e}`)
          .join("&");
        axios
          .get(`${strapiUrl}users?${query}`,
            {
              headers,
              withCredentials: true
            })
          .then((users) => {
            addArr.forEach((data: Record<string, any>) => {
              let sendAddObj: Record<string, any> = {};
              Object.keys(data).forEach((key) => {
                const fieldType = fields[key as keyof typeof fields];
                switch (fieldType) {
                  case FIELDS_TYPES.USER:
                    if (data[key] && Array.isArray(users?.data)) {
                      const user = users.data.find(
                        (u: { email: string; id: number }) => data[key] === u.email
                      );
                      if (user) {
                        sendAddObj = {
                          ...sendAddObj,
                          [key]: user.id,
                        };
                      }
                    }
                    break;
                  case FIELDS_TYPES.MULTI_USER:
                    if (Array.isArray(data[key]) && Array.isArray(users?.data)) {
                      sendAddObj = {
                        ...sendAddObj,
                        [key]: users.data
                          .filter(
                            (u: { email: string; id: number }) =>
                              data[key].includes(u.email)
                          )
                          .map((u: { email: string; id: number }) => u.id),
                      };
                    }
                    break;
                  default:
                    sendAddObj = { ...sendAddObj, [key]: data[key] };
                    break;
                }
              });
              sendAddArr = [...sendAddArr, sendAddObj];
            });
            let requests: any = [];
            console.log("sendAddArr: ", sendAddArr);
            sendAddArr.forEach((sendObj: any) => {
              const id = sendObj["id"];
              requests = [
                ...requests,
                axios.get(
                  `${strapiUrl}${listStrapiApi}?filters[id][$eq]=${id}`,
                  {
                    headers,
                    withCredentials: true
                  }
                ),
              ];
            });
            Promise.all(requests).then((values) => {
              console.log("values: ", values);
              requests = [];
              values.forEach((value, idx) => {
                const documentID = value.data.data[0]["documentId"];
                delete sendAddArr[idx]["id"];
                requests = [
                  ...requests,
                  axios.put(
                    `${strapiUrl}${listStrapiApi}/${documentID}`,
                    { data: sendAddArr[idx] },
                    {
                      headers,
                      withCredentials: true,
                    }
                  ),
                ];
              });
              Promise.all(requests).then((values) => {
                let ids: number[] = [];
                console.log("RESULT_MULTI_UPDATE_STRAPI: ", values);
                values.forEach((value) => {
                  ids = [...ids, value.data.data.id];
                });
                workstationNewUsersContextPromise
                  .then(syncWorkstationNewUsersFamiliarization)
                  .catch((error) => console.error("syncWorkstationNewUsersFamiliarization", error))
                  .finally(() => resolve(ids));
              });
            });
          });
      } else {
        let requests: any = [];
        addArr.forEach((sendObj: any) => {
          const id = sendObj["id"];
          requests = [
            ...requests,
            axios.get(`${strapiUrl}${listStrapiApi}?filters[id][$eq]=${id}`, {
              headers,
              withCredentials: true,
            }),
          ];
        });
        Promise.all(requests).then((values) => {
          requests = [];
          values.forEach((value, idx) => {
            const documentID = value.data.data[0]["documentId"];
            delete addArr[idx]["id"];
            requests = [
              ...requests,
              axios.put(
                `${strapiUrl}${listStrapiApi}/${documentID}`,
                { data: addArr[idx] },
                {
                  headers,
                  withCredentials: true,
                }
              ),
            ];
          });
          Promise.all(requests).then((values) => {
            let ids: number[] = [];
            console.log("RESULT_MULTI_UPDATE_STRAPI: ", values);
            values.forEach((value) => {
              ids = [...ids, value.data.data.id];
            });
            workstationNewUsersContextPromise
              .then(syncWorkstationNewUsersFamiliarization)
              .catch((error) => console.error("syncWorkstationNewUsersFamiliarization", error))
              .finally(() => resolve(ids));
          });
        });
      }
    } else {
      if (emails.length > 0) {
        const query = [..._.uniqWith(emails, _.isEqual)]
          .filter((e) => e && e !== "undefined" && e !== "null")
          .map((e) => `filters[email][$in]=${e}`)
          .join("&");
        axios
          .get(`${strapiUrl}users?${query}`,
            {
              headers,
              withCredentials: true
            })
          .then((users) => {
            let sendAddObj: Record<string, any> = {};
            Object.keys(addObj).forEach((key) => {
              const fieldType = fields[key as keyof typeof fields];
              switch (fieldType) {
                case FIELDS_TYPES.USER:
                  if (addObj[key] && Array.isArray(users?.data)) {
                    const user = users.data.find(
                      (u: { email: string; id: number }) => addObj[key] === u.email
                    );
                    if (user) {
                      sendAddObj = {
                        ...sendAddObj,
                        [key]: user.id,
                      };
                    }
                  }
                  break;
                case FIELDS_TYPES.MULTI_USER:
                  if (Array.isArray(addObj[key]) && Array.isArray(users?.data)) {
                    sendAddObj = {
                      ...sendAddObj,
                      [key]: users.data
                        .filter(
                          (u: { email: string; id: number }) =>
                            addObj[key].includes(u.email)
                        )
                        .map((u: { email: string; id: number }) => u.id),
                    };
                  }
                  break;
                default:
                  sendAddObj = { ...sendAddObj, [key]: addObj[key] };
                  break;
              }
            });
            let id = sendAddObj["id"];
            let updateObj = { ...sendAddObj };
            delete updateObj["id"];
            axios
              .get(`${strapiUrl}${listStrapiApi}?filters[id][$eq]=${id}`, {
                headers,
                withCredentials: true,
              })
              .then((value) => {
                const documentID = value.data.data[0]["documentId"];
                axios
                  .put(
                    `${strapiUrl}${listStrapiApi}/${documentID}`,
                    { data: updateObj },
                    {
                      headers,
                      withCredentials: true,
                    }
                  )
                  .then((res) => {
                    console.log("RESULT_SINGLE_UPDATE_STRAPI: ", res);
                    workstationNewUsersContextPromise
                      .then(syncWorkstationNewUsersFamiliarization)
                      .catch((error) => console.error("syncWorkstationNewUsersFamiliarization", error))
                      .finally(() => resolve([res.data.data["id"]]));
                  });
              });
          });
      } else {
        let id = addObj["id"];
        let updateObj = { ...addObj };
        delete updateObj["id"];
        axios
          .get(`${strapiUrl}${listStrapiApi}?filters[id][$eq]=${id}`, {
            headers,
            withCredentials: true,
          })
          .then((value) => {
            const documentID = value.data.data[0]["documentId"];
            axios
              .put(
                `${strapiUrl}${listStrapiApi}/${documentID}`,
                { data: updateObj },
                {
                  headers,
                  withCredentials: true
                }
              )
              .then((res) => {
                console.log("RESULT_SINGLE_UPDATE_STRAPI: ", res);
                workstationNewUsersContextPromise
                  .then(syncWorkstationNewUsersFamiliarization)
                  .catch((error) => console.error("syncWorkstationNewUsersFamiliarization", error))
                  .finally(() => resolve([res.data.data["id"]]));
              });
          });
      }
    }
  });
};
